import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core';

import { setCurrentLeg } from '../../actions/legs';
import { getCurrentLeg, getAllFlightTaskLeg } from '../../selectors/screen';
import { getSendedLegs } from '../../selectors/sended-data';
import { useSize } from '../hooks/useSize';
import { BREAKPOINTS, BREAKPOINTS_CANCEL, MIN_WIDTH_SHOW_CANCEL, Status } from './constants';
import { getSlides } from './tools';
import { useStyles } from './useStyles';
import { useLanguage } from '../hooks/useLanguage/useLanguage';

export const useBottomFlightBar = () => {
    const { isEng } = useLanguage();
    const legs = useSelector(getAllFlightTaskLeg) || [];
    const legsWithChanges = useSelector(getSendedLegs);
    const currentLeg = useSelector(getCurrentLeg) || {};
    const { width } = useSize();
    const dispatch = useDispatch();
    const theme = useTheme();
    const classes = useStyles();
    const { t: translate } = useTranslation();
    const showCancel = width >= MIN_WIDTH_SHOW_CANCEL;

    const onClickLeg = useCallback((legId) => dispatch(setCurrentLeg(legId)), []);

    const getLegStatus = useCallback(
        (id) => {
            const leg = legsWithChanges[id];
            if (leg) {
                return leg.hasChanges ? Status.EDIT : Status.SEND;
            }

            return Status.NONE;
        },
        [legsWithChanges]
    );

    const slides = useMemo(getSlides(legs, currentLeg, showCancel, classes, translate, getLegStatus, onClickLeg, isEng), [
        legs,
        currentLeg,
        showCancel,
        theme,
        translate,
        getLegStatus,
        onClickLeg,
        isEng,
    ]);

    const activeSlide = currentLeg && slides.findIndex((slide) => slide.id === currentLeg.id);
    const breakpoints = useMemo(() => {
        if (legs.some((leg) => leg.flightCancel)) {
            return BREAKPOINTS_CANCEL;
        }

        return BREAKPOINTS;
    }, [legs]);

    return {
        activeSlide,
        breakpoints,
        slides,
    };
};
